/* eslint-disable prettier/prettier */
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const functions = JSON.parse(localStorage.getItem('functionsData') || '[]');

    const token = localStorage.getItem('dbTokenData');
    const userId = localStorage.getItem('userid');

    const currentPath = location.pathname.toLowerCase();

    const publicRoutes = ['/', '/login'];

    const baseRoutes = [
      '/home',
      '/employeeprofile',
      '/kitchenorderticket',
      '/workflow/designer',
      '/workflow/formbuilder',
      '/workitem/add',
      '/workitem/edit',
      '/workflow/formeditor',
      '/board/stage'
    ];

    const dynamicRoutes = ['/workitem/add', '/workitem/edit'];

    // allow login routes
    if (publicRoutes.includes(currentPath)) {
      return;
    }

    // block direct access without login
    if (!token || !userId) {
      navigate('/login', { replace: true });
      return;
    }

    // allow dynamic routes
    if (dynamicRoutes.includes(currentPath)) {
      const parentRoute = location.state?.parentRoute || sessionStorage.getItem('parentRoute');

      if (parentRoute) return;
    }

    // allow base routes
    if (baseRoutes.includes(currentPath)) {
      return;
    }

    // permission check
    const hasPermission = functions.some((fn) => fn.launch && fn.launch.toLowerCase() === currentPath);

    if (!hasPermission) {
      localStorage.setItem('pd', true);
      navigate('/home', { replace: true });
    }
  }, [location.pathname, location.state, navigate]);

  return children;
}
